import { React, useEffect, useState, useContext } from 'react'
import { Link as LinkTo, useLocation } from 'react-router-dom'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import Link from '@material-ui/core/Link'

import UserMenu from './UserMenu'
import { description } from '../../../../package.json'
import AuthContext from 'store/AuthContext'
import styles from '../global.module.scss'

const useBreadCrumb = () => {
  const [path, setPath] = useState([])
  const location = useLocation()

  useEffect(() => {
    if (location.pathname === '/') {
      setPath([])
    } else {
      const locationArray = location.pathname.split('/').slice(1)
      setPath(locationArray)
    }
  }, [location])
  return path
}

const TopBar = () => {
  // const path = useBreadCrumb()
  const {
    state: { auth },
  } = useContext(AuthContext)

  return (
    <div className={styles.topbarRoot}>
      <Link component={LinkTo} to="/" className={styles.linkHead}>
        {description}
      </Link>
      {/* <Breadcrumbs
        aria-label="breadcrumb"
        separator={<NavigateNextIcon fontSize="small" />}
      >
        {path.length > 0 && (
          <Link component={LinkTo} to="/" className={styles.linkHead}>
            {description}
          </Link>
        )}{' '}
        {path.map((i, j) => {
          return (
            <Link
              component={LinkTo}
              key={i}
              to={`/${path.slice(0, j + 1).join('/')}`}
              className={styles.link}
              // color="secondary"
            >
              {i}
            </Link>
          )
        })}
      </Breadcrumbs> */}

      {auth && <UserMenu />}
    </div>
  )
}

export default TopBar
